class LookbookSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.lookbook__grid');
    this.navWrapper = this.querySelector('.lookbook__nav-wrapper');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider) return;

    this.autoplay = this.dataset.autoplay === 'true';
    this.speed = parseInt(this.dataset.speed, 10) || 5;
    this.autoplayInterval = null;
    this.isHovered = false;

    if (this.prevButton && this.nextButton) {
      this.prevButton.addEventListener('click', this.scrollPrev.bind(this));
      this.nextButton.addEventListener('click', this.scrollNext.bind(this));
    }

    this.slider.addEventListener('scroll', this.updateButtons.bind(this));

    this.resizeObserver = new ResizeObserver(() => this.updateButtons());
    this.resizeObserver.observe(this.slider);

    if (this.autoplay) {
      this.initAutoplay();
    }

    this.updateButtons();
  }

  getScrollAmount() {
    return this.slider.offsetWidth * 0.5;
  }

  scrollPrev() {
    this.slider.scrollBy({
      left: -this.getScrollAmount(),
      behavior: 'smooth'
    });
  }

  scrollNext() {
    this.slider.scrollBy({
      left: this.getScrollAmount(),
      behavior: 'smooth'
    });
  }

  initAutoplay() {
    this.addEventListener('mouseenter', () => {
      this.isHovered = true;
      this.stopAutoplay();
    });

    this.addEventListener('mouseleave', () => {
      this.isHovered = false;
      this.startAutoplay();
    });

    this.addEventListener('focusin', () => {
      this.stopAutoplay();
    });

    this.addEventListener('focusout', () => {
      if (!this.isHovered) {
        this.startAutoplay();
      }
    });

    this.startAutoplay();
  }

  startAutoplay() {
    if (this.autoplayInterval) return;

    this.autoplayInterval = setInterval(() => {
      this.autoScroll();
    }, this.speed * 1000);
  }

  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }

  autoScroll() {
    const isScrollable = this.slider.scrollWidth > this.slider.clientWidth;
    if (!isScrollable) return;

    const scrollLeft = Math.round(this.slider.scrollLeft);
    const maxScroll = this.slider.scrollWidth - this.slider.offsetWidth;

    if (scrollLeft >= maxScroll - 5) {
      this.slider.scrollTo({
        left: 0,
        behavior: 'smooth'
      });
    } else {
      this.scrollNext();
    }
  }

  updateButtons() {
    const isScrollable = this.slider.scrollWidth > this.slider.clientWidth;

    if (this.navWrapper) {
      this.navWrapper.style.display = isScrollable ? '' : 'none';
    }

    if (!isScrollable || !this.prevButton || !this.nextButton) return;

    const scrollLeft = Math.round(this.slider.scrollLeft);
    const maxScroll = this.slider.scrollWidth - this.slider.offsetWidth;

    if (scrollLeft <= 5) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (scrollLeft >= maxScroll - 5) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }
}

customElements.define('lookbook-slider', LookbookSlider);